/* global dataLayer, picturefill */

// -------------------------------------------------    -------------------------
// #126 - ACTIVITY COMPLETION
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('../modal');
var modalDisplay = new ModalDisplay();
var reinitModules = require('../../utilities/reinit-modules');

module.exports = function (options) {
    var context = options.context;

    function reinitialiseModules() {

        var modules = [{
            name: 'social-reward-modal',
            module: require('../rewarding/social-reward-modal')
        }];

        reinitModules(modules);
    }

    function updatePersonalPlan() {
        $.ajax({
            data: 'PersonalPlanCompletedModule=',
            type: 'post',
            url: window.location.href,
            success: function success(data) {
                var $data = $(data);
                var ajaxCompletedHero = $data.find('[data-binding="personal-plan-completed"]');

                if (ajaxCompletedHero.length) {
                    $('[data-binding="personal-plan-statement"]').prepend(ajaxCompletedHero);

                    //Google tag manager function
                    dataLayer.push({ 'event': 'allActivitiesCompleted' });
                }

                /// Reinitialise picturefill
                if (typeof window.HTMLPictureElement !== 'function') {
                    picturefill();
                }
            }
        });
    }

    function init() {

        var activityForm = context.find('form');

        activityForm.off();

        $('.modal[class*="reward"]').remove();

        $('[data-behavior="personal-plan-activity-completion"]').each(function (i) {
            var thisContext = $(this);
            var $modalContent = thisContext.find('[data-binding="modal"]');

            thisContext.find('.info').off();

            modalDisplay.externalModal(thisContext, $modalContent, 'reward' + i);
        });

        activityForm.on('submit', function (e) {
            var activityWrapper = $(this).parents('.personal-plan-activity-item__wrapper');
            var activityForm = $(this);
            var activeButton = activityForm.find('[data-binding="activity-completion-button"]');
            var activeButtonLoadingText = activeButton.data('loading-text');

            var isPersonalPlan = false;
            var isEditorialActivity = false;
            var hiddenInput = activityForm.find('#activityType');
            var hiddenInputVal = hiddenInput.val();

            e.preventDefault();
            activeButton.addClass('disabled');
            activeButton.find('.button__text').text(activeButtonLoadingText);

            if (activityForm.parents('[data-binding="personal-plan-activities"]').length) {

                if (hiddenInputVal === 'ActivityInMyPlan') {
                    isPersonalPlan = true;
                } else {
                    isPersonalPlan = false;
                }
            }

            if (activityForm.parents('[data-binding="editorial-activities"]').length) {
                isEditorialActivity = true;
            }

            $.ajax({
                data: activityForm.serialize() + '&showShare=true' + '&' + activeButton.attr('name') + '=',
                type: activityForm.attr('method'),
                url: activityForm.attr('action'),
                success: function success(data) {
                    var $data = $(data);
                    var interstitialState = $data.find('.personal-plan-activity-item--interstitial');
                    var completedState = $data.find('.personal-plan-activity-item--completed');

                    activityWrapper.replaceWith($data);

                    /// Editorial activities should not show interstitial state
                    if (isEditorialActivity === true) {
                        interstitialState.replaceWith(completedState);
                        completedState.show();
                    }

                    /// Reinitialise picturefill
                    if (typeof window.HTMLPictureElement !== 'function') {
                        picturefill();
                    }

                    interstitialState.on('click', 'a', function (e) {
                        /// Social share buttons need to trigger actions as usual, text links need to be stopped
                        if (!$(this).hasClass('social-share__link')) {
                            e.preventDefault();
                        }

                        interstitialState.replaceWith(completedState);
                        completedState.show();
                        init();
                    });

                    if (isPersonalPlan === true) {
                        updatePersonalPlan();
                    } else {
                        reinitialiseModules();
                    }

                    init();
                }
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/personal-plan/personal-plan-activity-completion.js
// module id = 65
// module chunks = 0